import api from './api';

export interface SendNotificationRequest {
  userIds: string[];
  title: string;
  body: string;
  data?: Record<string, string>;
}

export interface BroadcastRequest {
  title: string;
  body: string;
  data?: Record<string, string>;
}

export interface NotificationResponse {
  message: string;
  method?: 'direct' | 'background';
  jobId?: string;
  hangfireUrl?: string;
}

export async function sendNotification(data: SendNotificationRequest): Promise<NotificationResponse> {
  const response = await api.post('/admin/notifications/send', data);
  return response.data;
}

export async function broadcastNotification(data: BroadcastRequest): Promise<NotificationResponse> {
  const response = await api.post('/admin/notifications/broadcast', data);
  return response.data;
}

export async function testNotification(userId: string): Promise<NotificationResponse> {
  const response = await api.get(`/admin/notifications/test/${userId}`);
  return response.data;
}

export async function getNotificationStats(): Promise<any> {
  const response = await api.get('/admin/notifications/stats');
  return response.data;
}
